import {
  getCardPayment,
  getOpenBankingPayment,
  getThirdPartyPayment,
} from "@api";
import { useEffect } from "react";
import {
  useNavigate,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import PaymentProcessing from "../../shared/PaymentProcessing";

const PRProcessing = () => {
  const { merchant, setWebhookPrResponse, refreshPaymentRequest } =
    useOutletContext();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get("p-id");
  const type = searchParams.get("t");

  useEffect(() => {
    const pollPaymentStatus = async () => {
      let paymentData = null;
      if (type === "card") {
        paymentData = await getCardPayment(paymentId);
      }
      if (type === "openbanking") {
        paymentData = await getOpenBankingPayment(paymentId);
      }
      if (type === "thirdparty") {
        paymentData = await getThirdPartyPayment(paymentId);
      }

      setWebhookPrResponse(paymentData);

      if (
        paymentData.status === "Processing" ||
        paymentData.status === "Initialized"
      ) {
        setTimeout(pollPaymentStatus, 500);
      } else {
        pollRequestStatus();
        return;
      }
    };

    const pollRequestStatus = async () => {
      const data = await refreshPaymentRequest();

      if (
        data.status === "PaymentProcessing" ||
        data.status === "Processing" ||
        data.status === "Requested" ||
        (data.status === null && data.paidOn == null) // for checkout payments where the status is always null and the paidOn has not yet updated
      ) {
        setTimeout(pollRequestStatus, 500);
      }
    };

    // In happy path ob and card payment statuses are checked directly.
    // In this case these query params are present so the payment status can be polled.
    if (paymentId && type) {
      pollPaymentStatus();
    } else {
      // In the instance we are directed here not from a provider we use the payment request to fetch status.
      setTimeout(pollRequestStatus, 500);
    }
  }, [type, paymentId]);

  return <PaymentProcessing merchant={merchant} />;
};

export default PRProcessing;
